import api from '../config/api/google'

export const googleServices = {
    getLocation: ({ latitude, longitude }) =>
        api.get(`/geocode/json?latlng=${latitude},${longitude}&key=${process.env.REACT_APP_APIKEY_GOOGLE_MAPS}`)
}